import { ENV } from "../../../../src/app/interfaces/interfaces";

export const environment: ENV = {
    production: false,
    apiUrl: 'https://fexco.gateway.test.todotix.net/', //Test
    walletUrl: 'https://fexco.vouchers.test.todotix.net/', //Test
    type: 'fexco',
    title: 'Fexco 2026',
    subtitle: 'Pagina Oficial para la compra de entradas',
    description: 'Compra entradas para la FEXCO 2026',
    keywords: 'tiendas, conciertos, entradas, tickets, fexco',
    yearProyect: '2026',
    imgLogo: '/assets/img/logo-color.png',
    imgLogoSVG: '/assets/img/logo-2026-white.png',
    imgLogoWhiteSVG: '/assets/img/logo-2026.png',
    imgLogoWhite: '/assets/img/logo.png',
    imgLogoHeader: '/assets/img/logo-2026-white.png',
    imgLogoFooter: '/assets/img/logo-2026-white.png',
    imgLogoRedirect: '/assets/img/logo-2026.png',

    authRedirect: '',

    // Seats IO
    region: 'sa',

    keyEncript: '12345678901234567890123456789012',
    ivEncript: '1234567890123456',

    keyRecaptcha: '6LdlO_AqAAAAABLkIe5fELcpOWg68FzaYxF-y5wL',
};
